/*
 * @Author: lishiqiao
 * @Date: 2022-01-19 14:14:44
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-19 15:01:03
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 14:59:01
     * @description: 年度经营目标完成情况--查询顶级机构下的所有子机构
     * @param {*} rootId 顶级机构id
     */
    getCompanyList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsOrgEgg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 15:00:55
     * @description: 年度经营目标完成情况--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getBreedTypeList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsTypeEgg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 15:01:38
     * @description: 年度经营目标完成情况--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getBreedList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsBreedEgg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 13:50:48
     * @description: 年度目标完成情况(汇总、明细)分页-(育苗、养成)
     * @param {*} params
     */
    getPageList(params) {
        const url = `/targetAnalysisOrg/searchTargetAnalysisOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 13:52:27
     * @description: 年度目标完成情况（汇总、明细）表-（育苗、养成）导出
     * @param {*} params
     */
    exportData(params) {
        const url = `/targetAnalysisOrg/exportTargetAnalysisOrgList`;
        return Page.exportDatas(url, params)
    }
}